export default function pick(object, fields) {
    return fields.reduce((acc, field) => {
        if (object[field]) {
            acc[field] = object[field];
        }

        return acc;
    }, {});
}
